import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { BsFillPersonFill } from "react-icons/bs";
import { HiOutlineViewGrid, HiViewGrid } from "react-icons/hi";
import { TfiEmail } from "react-icons/tfi";
import { GoHome } from "react-icons/go";
import { TbMessageQuestion } from "react-icons/tb";

const MobileFooter = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const isHome = pathname === '/';
  const isAbout = pathname === '/about';
  const isContact = pathname === '/contact-us';

  const isEnquiry =
  pathname === '/enquiry-ktc' ||
  pathname === '/enquiry-ktc/' ||
  /^\/enquiry-ktc\/[^/]+$/.test(pathname);

  const isCategoryPath =
    pathname.startsWith('/categories') ||
    /^\/[^/]+\/categories\/[^/]+/.test(pathname) ||
    /^\/[^/]+\/categories-detail\/[^/]+/.test(pathname);

  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [isCategorySelected, setIsCategorySelected] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowFooter(false); // scrolling down - hide
      } else {
        setShowFooter(true); // scrolling up - show
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const offcanvas = document.getElementById('offcanvasExample');

    const handleHidden = () => {
      if (!isCategorySelected) {
        setIsCanvasOpen(false);
      }
    };

    if (offcanvas) {
      offcanvas.addEventListener('hidden.bs.offcanvas', handleHidden);
    }

    return () => {
      if (offcanvas) {
        offcanvas.removeEventListener('hidden.bs.offcanvas', handleHidden);
      }
    };
  }, [isCategorySelected]);

  return (
    <Container fluid className={`mobile-footer ${showFooter ? 'show' : 'hide'}`}>
      <Row className="py-2 pt-2 fw-medium">
        {/* Home */}
        <Col className="px-0">
          <NavLink to="/" className="mobi-footer-icon d-flex flex-column align-items-center">
            <GoHome style={{ fontSize: '7vw', color: isHome ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isHome ? '#dc3545' : '#3E3E3E' }}>
              Home
            </span>
          </NavLink>
        </Col>

        {/* About Us */}
        <Col className="px-0">
          <NavLink to="/about" className="mobi-footer-icon d-flex flex-column align-items-center">
            <BsFillPersonFill style={{ fontSize: '7vw', color: isAbout ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isAbout ? '#dc3545' : '#3E3E3E' }}>
              About Us
            </span>
          </NavLink>
        </Col>

        {/* Category */}
        <Col className="px-0">
          <div
            className="mobi-footer-icon d-flex flex-column align-items-center"
            onClick={() => setIsCanvasOpen(true)}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasExample"
          >
            {isCategoryPath || isCanvasOpen ? (
              <HiViewGrid style={{ fontSize: '7vw', color: '#dc3545' }} />
            ) : (
              <HiOutlineViewGrid style={{ fontSize: '7vw', color: '#3E3E3E' }} />
            )}
            <span
              className="mt-0 fw-bold text-center them-font"
              style={{ color: isCategoryPath || isCanvasOpen ? '#dc3545' : '#3E3E3E' }}
            >
              Category
            </span>
          </div>
        </Col>

        {/* Contact */}
        <Col className="px-0">
          <NavLink to="/contact-us" className="mobi-footer-icon d-flex flex-column align-items-center">
            <TfiEmail style={{ fontSize: '7vw', color: isContact ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isContact ? '#dc3545' : '#3E3E3E' }}>
              Contact
            </span>
          </NavLink>
        </Col>

        {/* Enquiry */}
        <Col className="px-0">
          <NavLink to="/enquiry-ktc" className="mobi-footer-icon d-flex flex-column align-items-center">
            <TbMessageQuestion style={{ fontSize: '7vw', color: isEnquiry ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isEnquiry ? '#dc3545' : '#3E3E3E' }}>
              Enquiry
            </span>
          </NavLink>
        </Col>
      </Row>
    </Container>
  );
};

export default MobileFooter;
